export default from './Icon';



// WEBPACK FOOTER //
// ./src/sharedComponents/Icon/index.js